import React from 'react';
import type {DataGridServerProps} from '@igp/shared/components/data-grid';
import {DataGridServer} from '@igp/shared/components/data-grid';

import {useDataGridPlayerLevelReportV2Columns} from '../hooks';
import type {PlayerLevelReportV2ViewModel, PlayerLevelReportV2ViewModelKeys} from '../types';

type DataGridPlayerLevelReportV2Props = Omit<
    DataGridServerProps<PlayerLevelReportV2ViewModel, PlayerLevelReportV2ViewModelKeys>,
    'columns'
> & {columns: PlayerLevelReportV2ViewModelKeys[]};

export function DataGridPlayerLevelReportV2(props: DataGridPlayerLevelReportV2Props) {
    const columns = useDataGridPlayerLevelReportV2Columns(props.columns);
    return <DataGridServer {...props} columns={columns} />;
}
